import React, { useEffect } from 'react';
import { navigate } from 'gatsby';

const Edition2026Redirect = () => {
  useEffect(() => {
    navigate('/', { replace: true });
  }, []);
  return null;
};

export default Edition2026Redirect;
